// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1181":"4e8ebf95","1543":"26824349","3526":"d2211318","4263":"4a2850f8","4916":"5ebbf880","8731":"26824349"}[chunkId] + ".chunk.css";
};